import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "./TermsOfService.css";

function TermsOfService() {
  const navigate = useNavigate();

  return (
    <>
    <Helmet>
  <title>Terms of Service – Vedonica International</title>

  <meta
    name="description"
    content="Read the Terms of Service of Vedonica International regarding orders, payments, products, and website usage."
  />
</Helmet>
    <div className="terms-page">
      <div className="terms-container">
        <div className="terms-header">
          <span className="badge">Terms & Conditions</span>
          <h1>Vedonica International Terms of Service</h1>
          <p>
            Effective Date: April 2025 <br />
            Please read these terms carefully before using our website or making
            any purchase from Vedonica.
          </p>
        </div>

        <div className="terms-grid">

          <div className="terms-card">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing our website or placing an order, you agree to be
              legally bound by these Terms of Service and applicable laws.
            </p>
          </div>

          <div className="terms-card">
            <h2>2. Eligibility & Accounts</h2>
            <p>
              You must be 18 years or older to purchase. You are responsible for
              keeping your account credentials secure and information accurate.
            </p>
          </div>

          <div className="terms-card">
            <h2>3. Products & Availability</h2>
            <p>
              Product listings, images, and descriptions are for reference only.
              Availability may change without notice.
            </p>
          </div>

          <div className="terms-card">
            <h2>4. Pricing & Payments</h2>
            <p>
              Prices may change anytime. Payments are securely processed through
              trusted gateways and are never stored directly by us.
            </p>
          </div>

          <div className="terms-card">
            <h2>5. Orders & Cancellation</h2>
            <p>
              We reserve the right to accept, decline, cancel, or limit any
              order due to pricing, stock, or suspicious activity.
            </p>
          </div>

          <div className="terms-card">
            <h2>6. Acceptable Use</h2>
            <p>
              You agree not to misuse the website, upload harmful code, commit
              fraud, copy content, or violate any laws.
            </p>
          </div>

          <div className="terms-card">
            <h2>7. User Reviews & Content</h2>
            <p>
              Reviews or feedback submitted by users may be used by Vedonica for
              service improvements and promotional purposes.
            </p>
          </div>

          <div className="terms-card">
            <h2>8. Liability Disclaimer</h2>
            <p>
              Our website is provided “as is.” We do not guarantee uninterrupted
              access and are not liable for indirect losses.
            </p>
          </div>

          <div className="terms-card">
            <h2>9. Governing Law</h2>
            <p>
              These Terms are governed by the laws of India. Any disputes shall
              be handled under Indian jurisdiction.
            </p>
          </div>

          <div className="terms-card">
            <h2>10. Contact Us</h2>
            <p>
              For any questions regarding these terms, contact Vedonica support.
              <br />
              Support Hours: Monday – Saturday, 10:00 AM – 6:00 PM IST
            </p>
          </div>

        </div>

        <div className="terms-footer">
          <button className="home-btn" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

export default TermsOfService;